const Constants = {
  API_VERSION: '0.5',
};

export default Constants;
